/**
 * Known Country Codes
 */
export const CountryCodes = Object.freeze({
  US: 'US',
} as const);

/**
 * List of countries that use "zipcode" instead of "postal code"
 */
export const ZipCodeCountries = new Set(['US'] as const);

/**
 * List of countries that use "MMDDYY" instead of "DDMMYY"
 */
export const MMDDYYFormat = new Set(['US'] as const);

/**
 * List of countries that allow lyrics
 */
export const LyricsCountries = new Set(['US'] as const);

/**
 * List of countries that allow track samples
 */
export const TrackSampleCountries = new Set(['US'] as const);

/**
 * List of countries that have Flex features (skips, replays, simStream)
 */
export const FlexCountries = new Set(['US'] as const);

/**
 * List of countries where Premium is available.
 */
export const PremiumCountries = new Set(['US'] as const);

/**
 * List of countries where we can talk about Pandora for Business
 */
export const BusinessCountries = new Set(['US'] as const);
